// Pure parser functions extracted from InboxView for testability.

export function extractInboxMessages(text) {
  const msgs = [];
  const regex = /<INBOX_MESSAGE[^>]*subject="([^"]*)"[^>]*>([\s\S]*?)<\/INBOX_MESSAGE>/gi;
  let m;
  while ((m = regex.exec(text)) !== null) msgs.push({ subject: m[1].trim(), body: m[2].trim() });
  return msgs;
}

export function extractRecordOps(text) {
  const ops = [];
  const re = /<RECORD_OP\s+([\s\S]*?)(?:\/\s*>|>([\s\S]*?)<\/RECORD_OP>)/gi;
  let m;
  while ((m = re.exec(text)) !== null) {
    const attrs = {};
    m[1].replace(/(\w+)="([^"]*)"/g, (_, k, v) => { attrs[k] = v; });
    const body = m[2]?.trim();
    if (!attrs.collectionId && !attrs.collection) continue;
    let data = null;
    if (body) { try { data = JSON.parse(body); } catch {} }
    ops.push({
      action: attrs.action || 'update',
      collectionId: attrs.collectionId || null,
      collectionLabel: attrs.collection || null,
      recordId: attrs.recordId || null,
      field: attrs.field || null,
      value: attrs.value !== undefined ? attrs.value : null,
      data,
    });
  }
  return ops;
}

export function extractGithubOps(text) {
  const ops = [];
  const re = /<GITHUB_OP\s+([\s\S]*?)(?:\/\s*>|>([\s\S]*?)<\/GITHUB_OP>)/gi;
  let m;
  while ((m = re.exec(text)) !== null) {
    const attrs = {};
    m[1].replace(/(\w+)="([^"]*)"/g, (_, k, v) => { attrs[k] = v; });
    if (!attrs.action) continue;
    ops.push({ ...attrs, body: m[2]?.trim() || '' });
  }
  return ops;
}

export function extractGateRequests(text) {
  const reqs = [];
  const re = /<GATE_REQUEST\s+([\s\S]*?)(?:\/\s*>|>([\s\S]*?)<\/GATE_REQUEST>)/gi;
  let m;
  while ((m = re.exec(text)) !== null) {
    const attrs = {};
    m[1].replace(/(\w+)="([^"]*)"/g, (_, k, v) => { attrs[k] = v; });
    if (!attrs.action) continue;
    reqs.push({
      gateId: attrs.gateId || null,
      gateLabel: attrs.gateLabel || 'Approval Gate',
      action: attrs.action,
      description: m[2]?.trim() || attrs.description || '',
    });
  }
  return reqs;
}

export function stripInboxMessages(text) {
  return text.replace(/<INBOX_MESSAGE[\s\S]*?<\/INBOX_MESSAGE>/gi, '').trim();
}

export function stripSpecialBlocks(text) {
  return text
    .replace(/<INBOX_MESSAGE[\s\S]*?<\/INBOX_MESSAGE>/gi, '')
    .replace(/<RECORD_OP[\s\S]*?(?:\/\s*>|<\/RECORD_OP>)/gi, '')
    .replace(/<GATE_REQUEST[\s\S]*?(?:\/\s*>|<\/GATE_REQUEST>)/gi, '')
    .replace(/<GITHUB_OP[\s\S]*?(?:\/\s*>|<\/GITHUB_OP>)/gi, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function filterInboxItems(items, { folder, filterWs, workspaceId, filterType, filterRead }) {
  return items.filter(i => {
    if (folder === 'starred') { if (!i.starred || i.folder === 'archive') return false; }
    else if (folder === 'archive') { if (i.folder !== 'archive') return false; }
    else if (folder === 'sent') { if (i.folder !== 'sent') return false; }
    else if (folder === 'inbox') { if (i.folder !== 'inbox' && i.folder) return false; }
    else { if (i.folder !== folder) return false; }
    if (filterWs === 'current') { if (i.workspaceId !== workspaceId) return false; }
    else if (filterWs !== 'all') { if (i.workspaceId !== filterWs) return false; }
    if (filterType === 'messages' && i.type === 'approval') return false;
    if (filterType === 'approvals' && i.type !== 'approval') return false;
    if (filterRead === 'unread' && i.read) return false;
    if (filterRead === 'read' && !i.read) return false;
    return true;
  });
}
